var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrivetrain(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.348,
    height: 19.349,
    viewBox: "0 0 19.348 19.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#343434;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-222.908 -917)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.668,3H4A1,1,0,0,0,3,4V9.338a1,1,0,0,0,1,1h.667a1,1,0,0,0,1-1V4A1,1,0,0,0,4.668,3ZM4.334,9.81l-.9-.9L3.9,8.435l.431.431.431-.431.472.472Zm0-1.668-.9-.9L3.9,6.767l.431.431.431-.431.472.472Zm0-1.668-.9-.9L3.9,5.1l.431.431L4.766,5.1l.472.472Zm0-1.668-.9-.9L3.9,3.431l.431.431.431-.431.472.472Z",
    transform: "translate(219.908 914)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.668,39H4a1,1,0,0,0-1,1v5.337a1,1,0,0,0,1,1h.667a1,1,0,0,0,1-1V40A1,1,0,0,0,4.668,39Zm-.334,6.81-.9-.9.472-.472.431.431.431-.431.472.472Zm0-1.668-.9-.9.472-.472.431.431.431-.431.472.472Zm0-1.668-.9-.9L3.9,41.1l.431.431.431-.431.472.472Zm0-1.668-.9-.9.472-.472.431.431.431-.431.472.472Z",
    transform: "translate(219.908 890.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31,29.111v-5.79a2.324,2.324,0,0,1-2,0v5.791a2.323,2.323,0,0,1,2,0Zm-1.334-4.9h.667v.667h-.667Zm0,1.334h.667v.667h-.667Zm0,1.334h.667v.667h-.667Z",
    transform: "translate(202.581 900.458)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 0.344,
    cy: 0.344,
    rx: 0.344,
    ry: 0.344,
    transform: "translate(232.538 921.127)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.006,43.668a1.668,1.668,0,0,0-3.336,0V44H13v1.334H25.676V44h-4.67Zm-1.668,1a1,1,0,1,1,1-1A1,1,0,0,1,19.338,44.669Z",
    transform: "translate(213.244 888.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 0.344,
    cy: 0.344,
    rx: 0.344,
    ry: 0.344,
    transform: "translate(232.538 931.444)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13,13.334h4.67v.334a1.668,1.668,0,0,0,3.336,0v-.334h4.67V12H13Zm6.338-.667a1,1,0,1,1-1,1A1,1,0,0,1,19.338,12.667Z",
    transform: "translate(213.244 908.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M54.668,39H54a1,1,0,0,0-1,1v5.337a1,1,0,0,0,1,1h.667a1,1,0,0,0,1-1V40A1,1,0,0,0,54.668,39Zm-.334,6.81-.9-.9.472-.472.431.431.431-.431.472.472Zm0-1.668-.9-.9.472-.472.431.431.431-.431.472.472Zm0-1.668-.9-.9L53.9,41.1l.431.431.431-.431.472.472Zm0-1.668-.9-.9.472-.472.431.431.431-.431.472.472Z",
    transform: "translate(186.587 890.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M54.668,3H54a1,1,0,0,0-1,1V9.338a1,1,0,0,0,1,1h.667a1,1,0,0,0,1-1V4A1,1,0,0,0,54.668,3Zm-.334,6.81-.9-.9.472-.472.431.431.431-.431.472.472Zm0-1.668-.9-.9.472-.472.431.431.431-.431.472.472Zm0-1.668-.9-.9L53.9,5.1l.431.431.431-.431.472.472Zm0-1.668-.9-.9.472-.472.431.431.431-.431.472.472Z",
    transform: "translate(186.587 914)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivetrain);
export default __webpack_public_path__ + "static/media/drivetrain.4e2e2cffd91408fcbd6b9cfa2f80323e.svg";
export { ForwardRef as ReactComponent };